import { useState } from 'react';
import { cn } from '@/lib/utils';
import { UserCircle } from 'lucide-react';

interface AvatarProps {
	img_url: string;
	variant: 'square' | 'soft' | 'rounded' | 'circle';
	className?: string;
}

const Avatar = ({ img_url, variant = 'soft', className }: AvatarProps) => {
	const [failed, setFailed] = useState(false);

	if (!img_url || failed) {
		return (
			<div
				className={cn(
					'flex items-center justify-center bg-zinc-100 text-zinc-400',
					'h-10 w-10',
					{
						'rounded-none': variant === 'square',
						rounded: variant === 'soft',
						'rounded-md': variant === 'rounded',
						'rounded-full': variant === 'circle',
					},
					className,
				)}
				aria-hidden
			>
				<UserCircle className="h-6 w-6" />
			</div>
		);
	}

	return (
		<img
			src={img_url}
			onError={() => setFailed(true)}
			referrerPolicy="no-referrer"
			className={cn(
				'object-cover',
				'h-10 w-10 rounded-full',
				{
					'rounded-none': variant === 'square',
					rounded: variant === 'soft',
					'rounded-md': variant === 'rounded',
					'rounded-full': variant === 'circle',
				},
				className,
			)}
			alt="User avatar"
		/>
	);
};

export { Avatar };
